export const addQueryWildcards = (queryString: string) =>
  queryString
    .split(' ')
    .map((s) => `${s}*`)
    .join(' ')
